import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './music.json';

const Music = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Music vocabulary, genres, and cultural discussions. B2 level grammar, vocabulary, and speaking exercises."
            level="B2"
            title="Music"
            image="/Images/companypolicy3.webp"
            seoTitle="Free English Lesson Plans: Music"
            seoDescription="Music vocabulary, genres, and cultural discussions. B2 level grammar, vocabulary, and speaking exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Music;


